"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _lodash = require("lodash");

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _reactDom = require("react-dom");

var ReactDOM = _interopRequireWildcard(_reactDom);

var _reactBootstrap = require("react-bootstrap");

var _reactCssModules = require("react-css-modules");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactIntl = require("react-intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The wraps all children within it and provides a loading indicator when prop=true and disables all children under it
 */
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var Loader = require("halogen/BeatLoader");

var styles = require("./StatusWrapper.less");

var LOADER_STYLE = {
    display: "-webkit-flex",
    webkitFlex: "0 1 auto",
    flex: "0 1 auto",
    webkitFlexDirection: "column",
    flexDirection: "column",
    webkitFlexGrow: 1,
    flexGrow: 1,
    webkitFlexShrink: 0,
    flexShrink: 0,
    webkitFlexBasis: "25%",
    flexBasis: "25%",
    maxWidth: "25%",
    height: "200px",
    webkitAlignItems: "center",
    alignItems: "center",
    webkitJustifyContent: "center",
    justifyContent: "center"
};
var LOADER_COLOR = "#337ab7";
var StatusWrapper = function (_React$Component) {
    _inherits(StatusWrapper, _React$Component);

    function StatusWrapper() {
        var _Object$getPrototypeO;

        _classCallCheck(this, StatusWrapper);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(StatusWrapper)).call.apply(_Object$getPrototypeO, [this].concat(args)));

        _this.onErrorDismiss = function () {
            if (_this.props.onDismissError) {
                _this.props.onDismissError();
            } else {
                console.error("StatusWrapper error cannot be dismissed, no possibility provided!");
            }
        };
        return _this;
    }

    _createClass(StatusWrapper, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            if (this.props.error && this.props.onDismissError) {
                var tempRefs = this.refs;
                ReactDOM.findDOMNode(tempRefs.buttonDismissError).focus();
            }
        }
    }, {
        key: "render",
        value: function render() {
            var loaderClassName = this.props.isLoading ? "loader" : "loader-notLoading";
            var errorerClassName = this.props.error ? "errorer" : "errorer-notError";
            if (!this.props.children || this.props.hasChildren === false) {
                loaderClassName = "loader-noChildren";
                errorerClassName = "errorer-noChildren";
            }
            var loaderText = null;
            if ((0, _lodash.isString)(this.props.loadingText) && this.props.loadingText.length > 0) {
                loaderText = React.createElement("p", { styleName: "innerText" }, this.props.loadingText);
            }
            var loader = React.createElement("div", { styleName: loaderClassName }, React.createElement("div", { styleName: "inner" }, React.createElement(Loader, { style: LOADER_STYLE, color: LOADER_COLOR }), loaderText));
            var errorText = null;
            var alert = null;
            if (this.props.error) {
                if (this.props.errorText) {
                    errorText = React.createElement("p", null, this.props.errorText);
                } else {
                    if ((0, _lodash.isString)(this.props.error) && this.props.error.length > 0) {
                        // fallback, no errorText provided, but this.props.error is a string with more than 0 chars, indicating the error
                        errorText = React.createElement("p", { style: { whiteSpace: "pre-line" } }, React.createElement(_reactIntl.FormattedMessage, { id: "genericStatusError.description", values: {
                                error: this.props.error
                            } }));
                    } else if ((0, _lodash.isNumber)(this.props.error)) {
                        // fallback, no errorText provided, but this.props.error is a number, indicating that this is a errorCode/statusCode received from the server
                        errorText = React.createElement("p", null, React.createElement(_reactIntl.FormattedMessage, { id: "genericStatusError.code", values: {
                                error: this.props.error
                            } }));
                    } else if ((0, _lodash.isObject)(this.props.error) && this.props.error.cause && this.props.error.cause.statusCode && this.props.error.cause.error && this.props.error.cause.message) {
                        errorText = React.createElement("p", null, React.createElement(_reactIntl.FormattedMessage, { id: "genericStatusError.description", values: {
                                error: this.props.error.cause.statusCode + " " + this.props.error.cause.error + ": " + this.props.error.cause.message
                            } }));
                    } else if (this.props.error instanceof Error) {
                        errorText = React.createElement("p", { style: { whiteSpace: "pre-line" } }, React.createElement(_reactIntl.FormattedMessage, { id: "runtimeError", values: {
                                error: "" + this.props.error.message
                            } }));
                    } else {
                        // this.props.error is just true, could be any error...
                        errorText = React.createElement("p", null, React.createElement(_reactIntl.FormattedMessage, { id: "genericStatusError.any" }));
                    }
                }
                var errorButtonDismisser = null;
                if (this.props.onDismissError) {
                    errorButtonDismisser = React.createElement(_reactBootstrap.Button, { bsStyle: "default", ref: "buttonDismissError", onClick: this.onErrorDismiss }, React.createElement(_reactIntl.FormattedMessage, { id: "close" }));
                }
                alert = React.createElement(_reactBootstrap.Alert, { styleName: "alert", bsStyle: "danger", onDismiss: this.props.onDismissError ? this.onErrorDismiss : undefined }, React.createElement("h4", null, React.createElement(_reactIntl.FormattedMessage, { id: "error" })), errorText, React.createElement("p", null, errorButtonDismisser));
            }
            var errorer = React.createElement("div", { styleName: errorerClassName }, alert);
            return React.createElement("div", { className: this.props.className, styleName: "wrapper" }, this.props.children, loader, errorer);
        }
    }]);

    return StatusWrapper;
}(React.Component);
StatusWrapper.propTypes = {
    isLoading: React.PropTypes.bool.isRequired,
    error: React.PropTypes.oneOfType([
    // 3 types allowed...
    React.PropTypes.string.isRequired, React.PropTypes.number.isRequired, React.PropTypes.bool.isRequired, React.PropTypes.any.isRequired // any for PromiseState error reasons
    ]),
    onDismissError: React.PropTypes.func,
    errorText: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.element]),
    loadingText: React.PropTypes.string,
    hasChildren: React.PropTypes.bool,
    className: React.PropTypes.string,
    children: React.PropTypes.any
};
StatusWrapper = __decorate([(0, _reactCssModules2.default)(styles)], StatusWrapper);
exports.default = StatusWrapper;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/StatusWrapper.tsx
 ** module id = 42
 ** module chunks = 0
 **/